/**
 * Test IDs for QA automation.
 */
export const testIds = {
  drawerMenuNav: "drawer-menu-nav",
} as const;
